import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_2 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_3 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_5 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Cập nhật tài khoản" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Tên đăng nhập", -1)),
            _createVNode(_component_InputText, {
              id: "username",
              type: "text",
              modelValue: $setup.userUpdate.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userUpdate.username) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)),
            _createVNode(_component_Password, {
              id: "password",
              modelValue: $setup.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
              toggleMask: "",
              feedback: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Họ và tên", -1)),
            _createVNode(_component_InputText, {
              id: "fullname",
              type: "text",
              modelValue: $setup.userUpdate.fullname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userUpdate.fullname) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Số điện thoại", -1)),
            _createVNode(_component_InputText, {
              id: "phoneNumber",
              type: "text",
              modelValue: $setup.userUpdate.phoneNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userUpdate.phoneNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Chọn quyền hạn", -1)),
            _createVNode(_component_Dropdown, {
              id: "permission",
              modelValue: $setup.userUpdate.permission,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userUpdate.permission) = $event)),
              options: $setup.userPermission,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Vui lòng chọn quyền hạn của tài khoản ...",
              onChange: $setup.selectPermission
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          ($setup.userUpdate.permission == 'civilGroup')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "Chọn tổ", -1)),
                _createVNode(_component_Dropdown, {
                  id: "civilGroup",
                  modelValue: $setup.userUpdate.idCivilGroup,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userUpdate.idCivilGroup) = $event)),
                  options: $setup.listCivilGroup,
                  optionLabel: "civilGroupName",
                  placeholder: "Vui lòng chọn tổ ...",
                  filter: true
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Button, {
          label: "Cập nhật",
          icon: "pi pi-sync",
          iconPos: "left",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.doUpdate())),
          class: "mr-[2vw] w-[15vw]",
          disabled: !$setup.valid
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          label: "Xoá",
          severity: "danger",
          icon: "pi pi-user-minus",
          iconPos: "left",
          class: "w-[15vw]",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.del()))
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDeleteModal, {
      modelValue: $setup.showConfirmModal,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.showConfirmModal) = $event)),
      title: $setup.confirmTitle,
      message: $setup.confirmMessage,
      "is-loading": $setup.isConfirming,
      onConfirm: $setup.confirmDelete.confirm,
      onCancel: $setup.confirmDelete.cancel
    }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
  ], 64))
}